import { GlobalStyles, css } from "@mui/material";


export const globalStyles = (
	<GlobalStyles styles={ theme => css`
		ul, ol {
			list-style: none;
			padding: 0;
			margin: 0;
		}

		a {
			text-decoration: none;
		}
		
		.pad {
			padding: ${theme.spacing(2)}
		}

		.pad-sm {
			padding: ${theme.spacing(1)};
		}
		
		.pad-inline {
			padding-inline: ${theme.spacing(2)};
		}

		.pad-block {
			padding-block: ${theme.spacing(2)};
		}

		.mrg-block-end {
			margin-block-end: ${theme.spacing(2)};
		}

		.mrg-block-end-sm {
			margin-block-end: ${theme.spacing(1)};
		}
		
		.textWrapPretty {
			text-wrap: pretty;
		}

		.textOverImage {
			color: white;
			filter:
				drop-shadow(0px 0px 2px rgba(0,0,0,1))
				drop-shadow(0px 0px 8px rgba(0,0,0,.5))
				drop-shadow(0px 0px 16px rgba(0,0,0,.25))
				drop-shadow(0px 0px 18px rgba(0,0,0,.20))
			;
			text-shadow: 0 0 4px rgba(0,0,0,.5);
		}
		
		.tableAltColors {
			tbody {
				tr:nth-child(even) {
					background-color: ${theme.palette.grey[100]};
				}
			}
		}

		.textSecondary {
			color: ${theme.palette.text.secondary};
		}
		
		.navigableDataGrid {
			.MuiDataGrid-cell {
				cursor: pointer;
				&:focus {
					outline: none !important;
				}
				
				&:has(.MuiDataGrid-actionsCell) {
					cursor: default;
				}
			}
		}
	` }
	/>
);
